export var modalMixin = {
  data: function data() {
    return {
      item: {}
    };
  },
  methods: {
    showModalWithData: function showModalWithData(item, modalName) {
      this.item = item;
      this.$bvModal.show(modalName);
    }
  }
};